import { ActionTree, ActionContext } from 'vuex';
import { RootState } from '@/store';
import { State } from './state';
import { Mutations } from './mutations';
import { MessageActionTypes } from './action-types';
import { SegNotificacaoModel } from '@/models/message/seg-notificacao.model';
import { MessageMutationTypes } from './mutation-types';
import toastService from '@/services/globals/toast.service';
import helperService from '@/services/helper/helper.service';

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(key: K, payload: Parameters<Mutations[K]>[1]): ReturnType<Mutations[K]>;
} & Omit<ActionContext<State, RootState>, 'commit'>;

export interface Actions {
  [MessageActionTypes.ADD_MESSAGE](
    { commit }: AugmentedActionContext,
    params: {
      uid: string;
      message: SegNotificacaoModel;
    }
  ): void;
  [MessageActionTypes.DELETE_MESSAGE](
    { commit }: AugmentedActionContext,
    params: {
      uid: string;
      message: SegNotificacaoModel;
    }
  ): void;
  [MessageActionTypes.LIST_MESSAGES]({ commit }: AugmentedActionContext): SegNotificacaoModel[];
  [MessageActionTypes.SET_MESSAGES]({ commit }: AugmentedActionContext, messages: SegNotificacaoModel[]): void;
}

export const actions: ActionTree<State, RootState> & Actions = {
  [MessageActionTypes.ADD_MESSAGE]({ commit }, params) {
    if (params.message.tipoNotificacao == 2) {
      const relatorioData = JSON.parse(params.message.mensagem);

      if (relatorioData.Result) toastService.alertaBootstrapRelatorio(relatorioData.FileName, relatorioData.URL_PDF);
      else toastService.alertaErro('Erro ao gerar o relatório, tente novamente ou entre em contato com a nossa equipe.');
    }
    if (params.message.tipoNotificacao == 3) {
      const relatorioData = JSON.parse(params.message.mensagem);
      const url = helperService.downloadBase64File(relatorioData.Base64, relatorioData.Name);
      if (relatorioData) toastService.alertaBootstrapRelatorio(relatorioData.Name, url);
      else toastService.alertaErro('Erro ao gerar o relatório, tente novamente ou entre em contato com a nossa equipe.');
    } else toastService.alertaSucesso('Voce acabou de receber uma nova mensagem');

    commit(MessageMutationTypes.ADD_MESSAGE, params.message);
  },
  [MessageActionTypes.DELETE_MESSAGE]({ commit }, params: { uid: string; message: SegNotificacaoModel }) {
    let obj = {} as any;
    if (localStorage.getItem('messages')) {
      obj = JSON.parse(localStorage.getItem('messages')!) as any;
    }

    obj[params.uid].splice(obj[params.uid].indexOf(params.message), 1);
    localStorage.setItem('messages', JSON.stringify(obj));

    commit(MessageMutationTypes.SET_MESSAGES, obj);
  },
  [MessageActionTypes.LIST_MESSAGES]({ state }): SegNotificacaoModel[] {
    return state.messages;
  },

  [MessageActionTypes.SET_MESSAGES]({ commit }, messages: SegNotificacaoModel[]): void {
    commit(MessageMutationTypes.SET_MESSAGES, messages);
  }
};
